import React, { Component } from "react";
import TextBtn from "../Buttons/Text";
import FullBtn from "../Buttons/Full";
import TimeSelector from "../SwipeToggle/times";
import selectedTimes from "./selectedTimes";
import { displayTime } from "./display";
import Modal, { CloseBtn, withModal } from "../Modal";
import cx from "../../utils/cx";
import s from "./index.css";

const emDash = "\u2013";

class TimeSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: {}
    };
  }

  editTime(current) {
    this.current = current;
    this.setState({ selected: current || {} });
    this.props.openModal();
  }

  timeChanged(selected) {
    this.setState({ selected });
  }

  saveTimeChange() {
    const { hours = [], setHours, createHours } = this.props;
    const { selected } = this.state;
    const hrs = hours.filter(t => t !== this.current).concat(selected);
    this.current ? setHours(hrs) : createHours(hrs);
    this.props.closeModal();
  }

  removeHour(hour) {
    this.props.removeHours(hour);
  }

  render() {
    const { open, closeModal, hours = [] } = this.props;
    const { selected } = this.state;
    return (
      <div>
        <div
          className="bold border-top border-bottom px-4 py-3 d-flex"
          onClick={() => this.editTime()}
        >
          <h5 className="m-0">Add a time</h5>
          <TextBtn className="p-0 ml-auto text-blue">
            <p
              className={cx({
                [s.rotate]: true,
                "m-0": true
              })}
            >
              +
            </p>
          </TextBtn>
        </div>

        <Modal open={open} onClose={closeModal} scale={false} fadeUp={false}>
          <div
            className="position-relative bg-white shadow-lg"
            style={{ height: 480 }}
          >
            <CloseBtn onClick={closeModal} />
            <div className="pb-2 font-18">
              <Time time={selected} />
            </div>
            <TimeSelector
              time={selected}
              onChange={time => this.timeChanged(time)}
            />
            <FullBtn
              fontSize={18}
              style={{ bottom: 0 }}
              disabled={!selected.hour || !selected.meridiem}
              className="position-absolute bg-blue text-white text-center bold py-2"
              onClick={() => this.saveTimeChange()}
            >
              Done
            </FullBtn>
          </div>
        </Modal>
        <div style={{ minHeight: 134 }}>
          {selectedTimes(hours).map((time, i) => (
            <Time
              border
              key={i}
              onEdit={() => this.editTime(time)}
              onRemove={() => this.removeHour(time)}
              time={time}
            />
          ))}
        </div>
      </div>
    );
  }
}

export const Time = ({ onEdit, onRemove, time, border }) => (
  <div
    className={cx({ "d-flex px-4 pointer": true, "border-bottom": border })}
    onClick={() => onEdit && onEdit()}
  >
    <p className="bold text-red text-center my-2 w-100 font-18">
      {displayTime(time)}
    </p>
    {onRemove && (
      <TextBtn
        onClick={ev => {
          ev.stopPropagation();
          onRemove();
        }}
        className="p-0 bold text-red"
        style={{ width: 24 }}
      >
        <p className="bold double m-0">{emDash}</p>
      </TextBtn>
    )}
  </div>
);

export default withModal(TimeSelect);



// WEBPACK FOOTER //
// ./src/components/TimeSelect/TimeSelect.js